// Predefined palette of chart-friendly colors (12 vibrant colors)
export const CHART_COLOR_PALETTE = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#FFA07A', // Light Salmon
  '#98D8C8', // Mint
  '#F7DC6F', // Yellow
  '#BB8FCE', // Purple
  '#85C1E2', // Sky Blue
  '#F8B739', // Orange
  '#52B788', // Green
  '#E85D75', // Pink
  '#6C5CE7', // Indigo
];

/**
 * Color name mapping for accessibility and user-friendly display
 * Maps hex color values to human-readable color names
 */
export const COLOR_NAMES: Record<string, string> = {
  '#FF6B6B': 'Red',
  '#4ECDC4': 'Teal',
  '#45B7D1': 'Blue',
  '#FFA07A': 'Light Salmon',
  '#98D8C8': 'Mint',
  '#F7DC6F': 'Yellow',
  '#BB8FCE': 'Purple',
  '#85C1E2': 'Sky Blue',
  '#F8B739': 'Orange',
  '#52B788': 'Green',
  '#E85D75': 'Pink',
  '#6C5CE7': 'Indigo',
};

/**
 * Generates a random color from the predefined palette
 * Used for auto-assigning colors to new options
 */
export const generateRandomColor = (): string => {
  const randomIndex = Math.floor(Math.random() * CHART_COLOR_PALETTE.length);
  return CHART_COLOR_PALETTE[randomIndex];
};
